var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('ckeditor',{staticClass:"editor",attrs:{"value":_vm.value,"config":_vm.config,"editor":_vm.editor,"disabled":_vm.disabled},on:{"input":_vm.onEditorInput,"ready":_vm.onEditorReady}}):_vm._e(),_vm._v(" "),_c('div',{ref:"container",staticClass:"toolbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }